import { CommonEnums } from 'src/app/shared/common.enums';

export class Rce_DxSubUnit {
    dxFlow_Id: number;
    dxJob_Id: number;
    dxUnit_Id: number;
    dxSubUnit_Id: number;
    dxSubUnitNm: string;
    cmd: string;
    conn_Id: string;
    conn_Db_Id: number;
    cmdType: number;
    dxUnit_TblNm: string;
    success_Codes: string;
    return_Cd: string;
    return_Msg: string;
    properties: string;
    updateDt: Date; // For interactive design
    dxUnit_Sql: string;//To maintain fwdattributes to check in precompile of interactive debug

    copyCmd: string;  //Read-Only
    dxUnitNm: string;  //Read-Only

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.dxJob_Id = CommonEnums.defaults.LONG_VAL;
        this.dxUnit_Id = CommonEnums.defaults.LONG_VAL;
        this.dxSubUnit_Id = CommonEnums.defaults.LONG_VAL;
        this.dxSubUnitNm = CommonEnums.defaults.STRING_EMPTY;
        this.cmd = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Id = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.cmdType = CommonEnums.defaults.LONG_VAL;
        this.dxUnit_TblNm = CommonEnums.defaults.STRING_EMPTY;
        this.success_Codes = CommonEnums.defaults.STRING_EMPTY;
        this.return_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.return_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.properties = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.dxUnit_Sql = CommonEnums.defaults.STRING_EMPTY;
        this.copyCmd = CommonEnums.defaults.STRING_EMPTY;
        this.dxUnitNm = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(rce_DxSubUnitTmp: Rce_DxSubUnit): Rce_DxSubUnit {
        let rce_DxSubUnit: Rce_DxSubUnit = new Rce_DxSubUnit();
        rce_DxSubUnit.copyFrom(rce_DxSubUnitTmp as Rce_DxSubUnit);
        return rce_DxSubUnit;
    }

    copy(): Rce_DxSubUnit {
        let rce_DxSubUnitTmp: Rce_DxSubUnit = new Rce_DxSubUnit();

        rce_DxSubUnitTmp.dxFlow_Id = this.dxFlow_Id;
        rce_DxSubUnitTmp.dxJob_Id = this.dxJob_Id;
        rce_DxSubUnitTmp.dxUnit_Id = this.dxUnit_Id;
        rce_DxSubUnitTmp.dxSubUnit_Id = this.dxSubUnit_Id;
        rce_DxSubUnitTmp.dxSubUnitNm = this.dxSubUnitNm;
        rce_DxSubUnitTmp.cmd = this.cmd;
        rce_DxSubUnitTmp.conn_Id = this.conn_Id;
        rce_DxSubUnitTmp.conn_Db_Id = this.conn_Db_Id;
        rce_DxSubUnitTmp.cmdType = this.cmdType;
        rce_DxSubUnitTmp.dxUnit_TblNm = this.dxUnit_TblNm;
        rce_DxSubUnitTmp.success_Codes = this.success_Codes;
        rce_DxSubUnitTmp.return_Cd = this.return_Cd;
        rce_DxSubUnitTmp.return_Msg = this.return_Msg;
        rce_DxSubUnitTmp.properties = this.properties;
        rce_DxSubUnitTmp.updateDt = this.updateDt;
        rce_DxSubUnitTmp.dxUnit_Sql = this.dxUnit_Sql;
        rce_DxSubUnitTmp.copyCmd = this.copyCmd;
        rce_DxSubUnitTmp.dxUnitNm = this.dxUnitNm;

        return rce_DxSubUnitTmp;
    }

    copyFrom(rce_DxSubUnitTmp: Rce_DxSubUnit): void {
        this.dxFlow_Id = rce_DxSubUnitTmp.dxFlow_Id;
        this.dxJob_Id = rce_DxSubUnitTmp.dxJob_Id;
        this.dxUnit_Id = rce_DxSubUnitTmp.dxUnit_Id
        this.dxSubUnit_Id = rce_DxSubUnitTmp.dxSubUnit_Id;
        this.dxSubUnitNm = rce_DxSubUnitTmp.dxSubUnitNm;
        this.cmd = rce_DxSubUnitTmp.cmd;
        this.conn_Id = rce_DxSubUnitTmp.conn_Id;
        this.conn_Db_Id = rce_DxSubUnitTmp.conn_Db_Id;
        this.cmdType = rce_DxSubUnitTmp.cmdType;
        this.dxUnit_TblNm = rce_DxSubUnitTmp.dxUnit_TblNm;
        this.success_Codes = rce_DxSubUnitTmp.success_Codes;
        this.return_Cd = rce_DxSubUnitTmp.return_Cd;
        this.return_Msg = rce_DxSubUnitTmp.return_Msg;
        this.properties = rce_DxSubUnitTmp.properties;
        this.updateDt = rce_DxSubUnitTmp.updateDt;
        this.dxUnit_Sql = rce_DxSubUnitTmp.dxUnit_Sql;
        this.copyCmd = rce_DxSubUnitTmp.copyCmd
        this.dxUnitNm = rce_DxSubUnitTmp.dxUnitNm;
    }

    compare(rce_DxSubUnitTmp: Rce_DxSubUnit): string {
        let rce_DxSubUnitString: string =this.toString(false);
        let rce_DxSubUnitTmpString: string = rce_DxSubUnitTmp.toString(false);

        if (rce_DxSubUnitString != rce_DxSubUnitTmpString) {
            return rce_DxSubUnitString + ', ' + rce_DxSubUnitTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Rce_DxSubUnit [dxFlow_Id=" + this.dxFlow_Id +
            ", dxJob_Id=" + this.dxJob_Id +
            ", dxUnit_Id=" + this.dxUnit_Id +
            ", dxSubUnit_Id=" + this.dxSubUnit_Id +
            ", dxSubUnitNm=" + this.dxSubUnitNm +
            ", cmd=" + this.cmd +
            ", conn_Id=" + this.conn_Id +
            ", conn_Db_Id ="+ this.conn_Db_Id+
            ", cmdType=" + this.cmdType +
            ", dxUnit_TblNm=" + this.dxUnit_TblNm +
            ", success_Codes=" + this.success_Codes +
            ", return_Cd=" + this.return_Cd +
            ", return_Msg=" + this.return_Msg +
            ", properties=" + this.properties;

        if (isNotCompare) {
            str += ", updateDt=" + this.updateDt +
                ", dxUnit_Sql=" + this.dxUnit_Sql +
                ", copyCmd=" + this.copyCmd +
                ", dxUnitNm=" + this.dxUnitNm;
        }

        str += ']';
        return str;
    }
}